import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountBalance } from 'src/app/shared/interfaces/account-balance.interface';
import { AccountService } from 'src/app/core/services/account.service';
import { Subscription } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'app-account-balance-billing-card',
    templateUrl: './account-balance-billing-card.component.html',
    styleUrls: ['./account-balance-billing-card.component.scss'],
    standalone: true,
    imports: [MatProgressSpinner]
})
export class AccountBalanceBillingCardComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  accountDetails: AccountBalance;
  cardStatus: string;
  hasData = false;

  constructor(private accountService: AccountService) {
  }

  ngOnInit() {
    this.fetchAccountData();
  }

  fetchAccountData() {
    this.subscription = this.accountService.getAccountBalance().subscribe(resp => {
      this.accountDetails = resp['accountDetails'];
      if (this.accountDetails.accountStatus) {
        if (this.accountDetails.accountStatus === 'balance due') {
          this.cardStatus = '';
        } else if (this.accountDetails.accountStatus === 'balance overdue') {
          this.cardStatus = 'warn';
        }
      }
      this.hasData = true;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
